import React from 'react';
import { observer } from 'mobx-react';

import { formatPrice } from 'helpers/utils';
import ProductCustomFieldValue from 'tickets/detail/components/aside/Aside/Products/ProductCustomFieldValue';
import { Card } from 'ui';

type Props = {
  product: BackendPublic.Products;
  ticket: BackendPublic.TicketDetail;
  productCustomFieldTypes: BackendPublic.ClientProductCustomFieldType[];
};

function Product({ product, ticket, productCustomFieldTypes }: Props) {
  return (
    <Card flat>
      <Card.Content>
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          {product.image_url && (
            <div className="flex-grow-0">
              <img
                src={product.image_url}
                alt={product.image_name || product.name}
                className="h-32 w-32 rounded-lg object-contain"
              />
            </div>
          )}
          <div className="flex-grow space-y-3">
            <div className="flex flex-wrap justify-between gap-1">
              <div className="flex text-lg">
                {product.amount && <span className="mr-1.5">{`${product.amount}× `}</span>}
                <h3 className="font-medium">{product.name}</h3>
                {!!product.variant && <span className="ml-3 text-gray-500">{product.variant}</span>}
              </div>
              {!!product.price && (
                <div className="font-medium text-gray-500">{formatPrice(product.price, ticket.currency)}</div>
              )}
            </div>

            <div className="space-y-4">
              {productCustomFieldTypes.map(
                (field) =>
                  product.custom_fields[field.id] && (
                    <ProductCustomFieldValue customField={field} customFields={product.custom_fields} />
                  ),
              )}
            </div>
          </div>
        </div>
      </Card.Content>
    </Card>
  );
}

export default observer(Product);
